import { render, staticRenderFns } from "./TheIndexArancel.vue?vue&type=template&id=567598d5&"
import script from "./TheIndexArancel.vue?vue&type=script&lang=js&"
export * from "./TheIndexArancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports